module.exports = __webpack_public_path__ + "img/guali2.80aaf927.jpg";